import { render, staticRenderFns } from "./duoradioSiteDialog.vue?vue&type=template&id=52ed0968&scoped=true"
import script from "./duoradioSiteDialog.vue?vue&type=script&lang=js"
export * from "./duoradioSiteDialog.vue?vue&type=script&lang=js"
import style0 from "./duoradioSiteDialog.vue?vue&type=style&index=0&id=52ed0968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ed0968",
  null
  
)

export default component.exports